export default __webpack_public_path__ + "static/texturepaper-e23da6265a1c6d2c8f1403491a58d9dd.png";